module.exports = __webpack_public_path__ + "img/f22.34e67b31.png";